import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { openEnquiry, scrollTo } from "../../lib/api";
import { Button } from "../ui/button";

const NAV = [
  ["tools", "Tools"], ["compare", "Rates"], ["how", "How it works"], ["track", "Track"],
  ["plans", "Plans"], ["faq", "FAQ"], ["contact", "Contact"],
];

export function Header() {
  const [open, setOpen] = useState(false);
  const [solid, setSolid] = useState(false);
  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const go = (id) => { scrollTo(id); setOpen(false); };

  return (
    <header className={`sticky top-0 z-50 transition-colors ${solid ? "bg-white/90 backdrop-blur-xl border-b border-[#e1e2e5]" : "bg-white"}`}>
      <div className="max-w-[1200px] mx-auto px-4 md:px-8 h-[72px] flex items-center justify-between gap-4">
        <a href="/" data-testid="header-logo" className="flex items-center gap-2 shrink-0" aria-label="Bhartiya Loan Capital home">
          <img src="/assets/logo.png" alt="Bhartiya Loan Capital" className="h-8 sm:h-10 w-auto" />
        </a>
        <nav className="hidden lg:flex items-center gap-1" aria-label="Primary">
          {NAV.map(([id, l]) => (
            <button key={id} data-testid={`header-nav-${id}`} onClick={() => go(id)}
              className="px-3 py-2 rounded-full text-sm font-bold text-[#191c1f] hover:bg-[#f4f5f6]">
              {l}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-2 shrink-0">
          <Button data-testid="check-eligibility-btn" onClick={() => openEnquiry({})}
            className="hidden sm:inline-flex bg-[#191c1f] hover:bg-black text-white rounded-full font-bold px-5 min-h-[44px]">
            Check eligibility
          </Button>
          <button data-testid="mobile-menu-btn" className="lg:hidden p-2 min-h-[44px] min-w-[44px]"
            aria-label="Menu" aria-expanded={open} aria-controls="mobile-menu" onClick={() => setOpen((o) => !o)}>
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>
      {open && (
        <div id="mobile-menu" className="lg:hidden border-t border-[#e1e2e5] bg-white px-4 py-3" data-testid="mobile-menu">
          <div className="grid grid-cols-2 gap-1">
            {NAV.map(([id, l]) => (
              <button key={id} onClick={() => go(id)} data-testid={`mobile-nav-${id}`}
                className="text-left px-3 py-3 rounded-xl font-bold hover:bg-[#f4f5f6]">{l}</button>
            ))}
          </div>
          <a href="tel:+917042249097" className="flex items-center gap-2 mt-2 px-3 py-3 font-bold text-[#004040]">
            <Phone size={18} /> +91 70422 49097
          </a>
        </div>
      )}
    </header>
  );
}
